/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 04.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import ReactSelect from "react-select";
import _ from "underscore";

import { asNumber } from "react-jsonschema-form/lib/utils";
import t from "../../../../trans";

class SelectWidget extends React.Component {
    static propTypes = {
        schema: PropTypes.object.isRequired,
        id: PropTypes.string.isRequired,
        options: PropTypes.shape({
            enumOptions: PropTypes.oneOfType([PropTypes.array,PropTypes.bool]),
            multi: PropTypes.bool,
            multiDelimiter: PropTypes.string,
            enum: PropTypes.arrayOf(PropTypes.string),
            enumNames: PropTypes.arrayOf(PropTypes.string)
        }).isRequired,
        value: PropTypes.any,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        readonly: PropTypes.bool,
        multiple: PropTypes.bool,
        autofocus: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
        placeholder: PropTypes.string,
        className: PropTypes.string
    };

    static defaultProps = {
        autofocus: false
    };

    constructor(props) {
        super(props);
        this.state = {};
        this.onBlur = this.onBlur.bind(this);
    }

    processValue(schema, value) {
        if (value == null || value === "") return undefined;

        switch (schema.type) {
            case "array":
                if (!schema.items) return value;
                return value.map(function (v) {
                    return this.processValue(schema.items, v);
                }.bind(this));

            case "boolean":
                if (_.isString(value)) return value.toLowerCase() === "true";
                return !!value;

            case "number":
            case "integer":
                return asNumber(value);

            default:
                return value;
        }
    }

    getValue(val, multiple, delimiter) {
        if (val == null) return null;

        if (multiple) {
            return [].slice.call(val).map(o => o.value);
        } else {
            if (_.isArray(val)) {
                // Join values to single value:
                return [].slice.call(val).map(o => o.value).join(delimiter);
            }
            return val.value;
        }
    }

    makeEnumOptions() {
        let enumItems = this.props.options.enum;
        let enumNames = this.props.options.enumNames;
        let options = [];
        for (let i = 0; i < enumItems.length; i++) {
            options.push({
                value: (enumNames && enumNames[i] ? enumNames[i] : enumItems[i]),
                label: enumItems[i]
            });
        }
        return options;
    }

    getItemForValue(value, emptyValue, multiple, delimiter) {
        if (!multiple) return this.getSingleValue(value, emptyValue);

        if (value == null) return emptyValue;
        if (_.isString(value)) {
            // Split by delimiter
            value = value.split(delimiter);
        }

        let result = [];
        for (let v of value) {
            let singleResult = this.getSingleValue(v, undefined);
            if (singleResult == null) continue;
            result.push(singleResult);
        }
        if (result.length == 0) return emptyValue;
        return result;
    }

    getSingleValue(value, emptyValue) {
        if (!value) return emptyValue;

        if (this.props.options.enumOptions) {
            let item = _.find(this.props.options.enumOptions, {value: value});
            if (item) return item;
        }

        // No option found:
        return {
            value: value,
            label: value
        }
    }

    onBlur(event) {
        if (!this.props.onBlur || this.props.multiple) return;
        this.props.onBlur(
            this.props.id,
            this.processValue(this.props.schema, this.getValue(event.target, this.props.multiple))
        );
    }

    render() {
        const {
            schema,
            id,
            options,
            value,
            disabled,
            readonly,
            multiple,
            autofocus,
            onChange
        } = this.props;
        let { enumOptions, searchable, multi, multiDelimiter } = options;
        const emptyValue = multiple ? [] : "";
        if (options && options.enum) {
            enumOptions = this.makeEnumOptions();
        }

        if (multi && multiDelimiter == null) multiDelimiter = " ";

        return (
            <ReactSelect
                id={id}
                className={this.props.className}
                isMulti={multiple || multi}
                value={this.getItemForValue(value, emptyValue, multiple || multi, multiDelimiter)}
                isDisabled={disabled || readonly}
                isClearable={true}
                isSearchable={searchable}
                autoFocus={autofocus}
                openMenuOnFocus={true}
                onBlur={this.onBlur}
                onChange={newValue => {
                    onChange(newValue == null ? undefined : this.processValue(schema, this.getValue(newValue, multiple, multiDelimiter)));
                }}
                options={!enumOptions ? [] : enumOptions}
                getOptionLabel={(o) => o.label}
                getOptionValue={(o) => o.value}
                noOptionsMessage={() => t("No results found")}
                styles={{menu: (base) => ({
                        ...base,
                        zIndex: "5 !important"
                    })}}
            />
        );
    }
}

export default SelectWidget;
